export const AppSidebarLink = {
  extends: 'Link',
  href: (el) => el.href || '#',
  flow: 'x',
  align: 'center left',
  gap: 'Z1',
  padding: 'Z A',
  round: 'C',
  cursor: 'pointer',
  fontSize: 'A',
  textDecoration: 'none',
  fontWeight: (el, s) => (s.root?.route || s.root?.currentPath || '/') === el.href ? '600' : '500',
  background: (el, s) => (s.root?.route || s.root?.currentPath || '/') === el.href ? 'overlay' : 'transparent',
  color: (el, s) => (s.root?.route || s.root?.currentPath || '/') === el.href ? 'title' : 'subtitle',
  ':hover': { background: 'overlay', color: 'title' },
  transition: 'background 120ms ease, color 120ms ease',

  Icon: {
    icon: (el) => el.parent.icon || 'state',
    boxSize: 'A',
    color: (el, s) => (s.root?.route || s.root?.currentPath || '/') === el.parent.href ? 'blue' : 'caption'
  },
  Label: { tag: 'span', text: (el) => el.parent.label || '' },

  onClick: (e, el, s) => {
    e.preventDefault()
    let rootEl = el
    while (rootEl && !rootEl.routes) rootEl = rootEl.parent
    const router = el.context?.utils?.router
    if (router && rootEl) {
      router(el.href, rootEl, {}, { pushState: true, scrollToTop: true })
    }
  }
}
